import { GameRouteService } from "../services/GameRouteService";

export type JournalEntry = {
    description: string;
    title: string;
    alias: string;
};

export class JournalComponent extends HTMLElement {
    /** Instance of the game route service */
    private readonly _gameRouteService: GameRouteService = new GameRouteService();

    public async connectedCallback(): Promise<void> {
        console.log("Fetching Journal");

        const data: JournalEntry[] = await this._gameRouteService.getJournal();
        this.render();

        const dataElement: HTMLElement = this.querySelector("#data")!;
        const titleElement: HTMLElement = this.querySelector("#title")!;
        const descriptionElement: HTMLElement = this.querySelector("#description")!;
        const backButton: HTMLElement = this.querySelector("#back-button")!;

        backButton.addEventListener("click", () => {
            location.reload();
        });

        let journalContent: string = "";

        data.forEach((entry: JournalEntry, index: number) => {
            const description: string = entry.description;
            const title: string = entry.title;
            const alias: string = entry.alias;
            console.log(description);
            console.log(title);
            console.log(alias);

            journalContent += `
                <div>
                    <button id="button-${index}" class="journal-title-button">${title}</button>
                </div>
            `;
        });

        dataElement.innerHTML = journalContent;

        data.forEach((entry: JournalEntry, index: number) => {
            const button: Element | null = this.querySelector(`#button-${index}`);
            if (button) {
                button.addEventListener("click", () => {
                    titleElement.innerHTML = entry.title;
                    descriptionElement.innerHTML = entry.description;
                });
            }
        });
    }

    private render(): void {
        this.innerHTML = `
            <style>
            .container {
                height: 100%;
                width: 100%;
                display: flex;
                background-color: rgba(0, 0, 0, 0.6);
                justify-content: center;
                opacity: 0; /* Start with 0 opacity */
                animation: fadeInJournal 1s ease-in-out forwards; /* Fade-in animation */
            }

            /* Keyframes for the fade-in effect */
            @keyframes fadeInJournal {
                0% {
                    opacity: 0;
                    transform: translateY(20px); /* Optional: slide effect */
                }
                100% {
                    opacity: 1;
                    transform: translateY(0); /* Reset sliding */
                }
            }

            /* Left side with journal titles */
            .journal-list {
                width: 500px;
                height: 80vh;
                overflow-y: auto;
                padding-right: 20px;
                border-right: 3px solid #8c7b6b;
                background-color: #f8e4b8;
                background-image: url('https://www.transparenttextures.com/patterns/old-map.png');
                box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.1);
                padding-top: 20px;
                padding-bottom: 20px;
                font-size: 1.2em;
                line-height: 1.6;
                animation: fadeInJournal 2s ease-in-out forwards; /* Apply fade-in to the journal list */
            }

            .journal-title-button {
                display: block;
                margin-bottom: 15px;
                padding: 12px;
                cursor: pointer;
                border: 2px solid #8c7b6b;
                border-radius: 8px;
                text-align: left;
                width: 100%;
                background-color: #f5e1c0;
                color: #5a3c23;
                font-weight: bold;
                font-family: 'UnifrakturMaguntia', serif; /* Google Font */
                transition: background-color 0.3s ease, transform 0.2s ease;
                opacity: 0; /* Initial opacity for fade-in effect */
                animation: fadeInButton 1s ease-in-out forwards;
            }

            /* Fade-in effect for buttons */
            @keyframes fadeInButton {
                0% {
                    opacity: 0;
                    transform: translateY(10px); /* Optional: slight slide down */
                }
                100% {
                    opacity: 1;
                    transform: translateY(0); /* Reset sliding */
                }
            }

            .journal-title-button:hover {
                background-color: #cda98b;
                transform: scale(1.05);
            }

            /* Right side with journal entry details */
            .journal-info {
                width: 500px;
                padding-left: 20px;
                background-color: #fdf1e1;
                background-image: url('https://www.transparenttextures.com/patterns/old-map.png');
                box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.1);
                border-radius: 12px;
                padding: 20px;
                height: 80vh;
                color: #3a2c1e;
                overflow-y: auto;
                font-family: 'Garamond', serif;
                opacity: 0; /* Initial opacity for fade-in effect */
                animation: fadeInJournal 2s ease-in-out forwards;
            }

            .journal-info h2 {
                font-size: 2.5em;
                margin-bottom: 15px;
                font-weight: bold;
                text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);
                font-family: 'UnifrakturMaguntia', serif; /* Old-fashioned font */
            }

            .journal-info p {
                font-size: 1.2em;
                line-height: 1.6;
                color: #4f3620;
                font-family: 'MedievalSharp', serif;
            }

            /* Adding subtle edge effects for a worn-out look */
            .journal-list, .journal-info {
                background-image: url('https://www.transparenttextures.com/patterns/old-map.png');
            }

            .journal-list, .journal-info {
                border-radius: 12px;
                box-shadow: 4px 4px 12px rgba(0, 0, 0, 0.4), inset 0 0 10px rgba(0, 0, 0, 0.1);
            }
        </style>

        <div class="back-button">
            <button id="back-button" class="journal-title-button">Back</button>
        </div>

        <div class="container">
            <!-- Left section for titles -->
            <div class="journal-list" id="data">
                <!-- Titles will be dynamically loaded here -->
            </div>
            <!-- Right section for selected journal entry -->
            <div class="journal-info">
                <div class="title" id="title">Selecteer een journalvermelding</div>
                <div class="description" id="description">Hier verschijnt de gedetailleerde beschrijving van de geselecteerde journalvermelding. Kies een item aan de linkerkant om verder te lezen.</div>
            </div>
        </div>
        `;
    }
}
